import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const merchantAppPrivilege = {
  namespaced: true,

  state: () => ({
    allMerchantAppPrivileges: []
  }),

  getters: {
    _allMerchantAppPrivileges: state => state.allMerchantAppPrivileges
  },

  mutations: {
    ALL_MERCHANT_APP_PRIVILEGES (state, data) {
      state.allMerchantAppPrivileges = data
    }
  },

  actions: {
    CreateMerchantAppPrivilege ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        api.post('/MerchantAppPriviledge/CreateMerchantAppPriviledge', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateMerchantAppPrivilege ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantAppPriviledge/UpdateMerchantAppPriviledge', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeleteMerchantMerchantAppPrivilege ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantAppPriviledge/DeleteMerchantMerchantAppPriviledge', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetAllMerchantAppPrivileges ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantAppPriviledge/GetAllMerchantAppPriviledges', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllMerchantAppPrivilegeByID ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantAppPriviledge/GetAllMerchantAppPriviledgeByID?MerchantAppPriviledgeID=${payload.merchantId}&merchatbeneficiarygroupID=${payload.merchatbeneficiarygroupID}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default merchantAppPrivilege
